import React, { useEffect, useState } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './RfidNfc.module.css'
import BasicTable from '../../components/Table/BasicTable';

import { 
  chipLfHeaderData, chipLfBodyata, 
  chipHfHeaderData, chipHfBodyData, 
  chipUhfHeaderData, chipUhfBodyData } from './rfidNfcData';

const ChipPage = () => {

  const [activeMenu, setActiveMenu] = useState(0);

  const handleMenuClick = (index) => {
    setActiveMenu(index);
  };

  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="rfid_nfc" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="rfid_nfc" />
        </div>
        <div className='com-content-wrap mb-50 mt-200'>
          <div style={{minHeight:'650px'}}>
            <div id={S.chipIntroText}>
              LF(125Khz), HF(13.56Mhz), UHF(900Mhz) 등 모든 주파수 대역의 다양한 RFID/NFC 칩을 사용 용도 및 <br />
              환경에 맞는 적합한 주파수대역 / 재질 / 사이즈 / 다양한 인쇄방식(옵셋, 실크, UV 등)으로 주문제작 카드/태그 형태로 제작 가능합니다.
            </div>
  
            <div id={S.chipMenuWrap} className={isMobile() ? 'mt-50' : 'mt-90'}>
              <div 
                className={`${S.chipMenu} ${activeMenu === 0 ? S.menuActive : ''}`}
                onClick={() => handleMenuClick(0)}
              >전체보기</div>
              <div 
                className={`${S.chipMenu} ${activeMenu === 1 ? S.menuActive : ''}`}
                onClick={() => handleMenuClick(1)}
              >LF</div>
              <div 
                className={`${S.chipMenu} ${activeMenu === 2 ? S.menuActive : ''}`}
                onClick={() => handleMenuClick(2)}
              >HF</div>
              <div 
                className={`${S.chipMenu} ${activeMenu === 3 ? S.menuActive : ''}`}
                onClick={() => handleMenuClick(3)}
              >UHF</div>
            </div>
  
            <div className='mb-30'>
              <div className={`${S.menuContent} ${activeMenu === 0 || activeMenu === 1? S.conActive : ''}`}>
                <div className={`${S.tableTitle} mt-30`}>LF(125Khz)</div>
                <BasicTable headers={chipLfHeaderData} items={chipLfBodyata} />
              </div>
              <div className={`${S.menuContent} ${activeMenu === 0 || activeMenu === 2 ? S.conActive : ''}`}>
                <div className={`${S.tableTitle} mt-30`}>HF(13.56Mhz)</div>
                <BasicTable headers={chipHfHeaderData} items={chipHfBodyData} />
              </div>
              <div className={`${S.menuContent} ${activeMenu === 0 || activeMenu === 3 ? S.conActive : ''}`}>
                <div className={`${S.tableTitle} mt-30`}>UHF(900Mhz)</div>
                <BasicTable headers={chipUhfHeaderData} items={chipUhfBodyData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChipPage;
